import { render, staticRenderFns } from "./item_conf.vue?vue&type=template&id=4662a588&scoped=true"
import script from "./item_conf.vue?vue&type=script&lang=ts"
export * from "./item_conf.vue?vue&type=script&lang=ts"
import style0 from "./item_conf.vue?vue&type=style&index=0&id=4662a588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4662a588",
  null
  
)

export default component.exports